"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./draggerComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Dragger = _antd.Upload.Dragger;

var DraggerComponent = function DraggerComponent(_ref) {
  var className = _ref.className,
      accept = _ref.accept,
      beforeUpload = _ref.beforeUpload,
      customRequest = _ref.customRequest,
      defaultFileList = _ref.defaultFileList,
      directory = _ref.directory,
      disabled = _ref.disabled,
      fileList = _ref.fileList,
      headers = _ref.headers,
      maxCount = _ref.maxCount,
      multiple = _ref.multiple,
      previewFile = _ref.previewFile,
      progress = _ref.progress,
      onChange = _ref.onChange,
      onPreview = _ref.onPreview,
      onRemove = _ref.onRemove,
      onDrop = _ref.onDrop,
      withCredentials = _ref.withCredentials,
      showUploadList = _ref.showUploadList,
      openFileDialogOnClick = _ref.openFileDialogOnClick,
      name = _ref.name,
      listType = _ref.listType,
      isImageUrl = _ref.isImageUrl,
      iconRender = _ref.iconRender,
      uploadingSucess = _ref.uploadingSucess,
      fileUpoadedFailed = _ref.fileUpoadedFailed,
      child = _ref.child;
  var props = {
    name: "file",
    multiple: true,
    onChange: function onChange(info) {
      var status = info.file.status;

      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }

      if (status === "done") {
        message.success("".concat(info.file.name, " ").concat(uploadingSucess));
      } else if (status === "error") {
        message.error("".concat(info.file.name, " ").concat(fileUpoadedFailed));
      }
    },
    onDrop: function onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(Dragger, _extends({}, props, {
    accept: accept,
    beforeUpload: beforeUpload ? beforeUpload : function () {
      return false;
    },
    customRequest: customRequest,
    defaultFileList: defaultFileList,
    directory: directory ? directory : false,
    disabled: disabled ? disabled : false,
    fileList: fileList,
    headers: headers,
    maxCount: maxCount ? maxCount : 5,
    multiple: multiple ? multiple : false,
    previewFile: previewFile,
    progress: progress,
    onChange: onChange,
    onPreview: onPreview,
    onRemove: onRemove,
    onDrop: onDrop,
    withCredentials: withCredentials ? withCredentials : false,
    showUploadList: showUploadList,
    openFileDialogOnClick: openFileDialogOnClick ? openFileDialogOnClick : true,
    name: name || "Upload",
    listType: listType,
    isImageUrl: isImageUrl,
    iconRender: iconRender,
    className: "".concat(className ? className : "")
  }), child);
};

var _default = DraggerComponent;
exports["default"] = _default;